var exports = {
  "c9": "x936d19a0--251e5d--rotating-arc",
  "e$": "x936d19a0--251e5d--rotate",
  "B8": "x936d19a0--251e5d--arc-path",
};

module.exports = exports;
